module.exports = __webpack_public_path__ + "img/search.c2d5c72e.png";